import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { AlertType, DisplayLocation, setAlerts } from '@app/redux';

import { NotificationLevel } from '@mfe/shared/schema-types';

export const useDisplayCIFAlert = () => {
  const { t } = useTranslation('Alerts');
  const dispatch = useDispatch();

  const displayCIFAlert = () =>
    dispatch(
      setAlerts([
        {
          level: NotificationLevel.Error,
          title: `${t('AccountStatus.disconnected.title')}`,
          caption: `${t('AccountStatus.disconnected.caption')}`,
          displayLocation: DisplayLocation.GLOBAL,
          type: AlertType.DisconnectedAccount,
        },
      ])
    );

  return displayCIFAlert;
};
